export default __webpack_public_path__ + "static/media/sms.6c16997e.svg";